import { React, useState } from "react";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";

const DigDaysDecisionForm = ({ decision, modalVisibility, digDay, handleDigDayDecision }) => {
  const [formValue, setformValue] = useState({
    digDayId: digDay.digDayId,
    decidedDigDayState: decision === "validation" ? 4 : decision === "adjustment" ? 3 : 1,
    message: undefined,
  });

  const submitButtonColor = decision === "validation" ? "success" : "warning";
  const submitButtonText =
    decision === "validation"
      ? "valider"
      : decision === "adjustment"
      ? "à ajuster"
      : decision === "cancel"
      ? "confirmer"
      : decision === "notification"
      ? "envoyer"
      : "rejeter";
  const formTitle =
    decision === "validation"
      ? "Souhaitez-vous procéder à la validation de ce digDay ?"
      : decision === "adjustment"
      ? "Souhaitez-vous demander un changement de la part de l'utilisateur ?"
      : decision === "cancel"
      ? "Souhaitez-vous annuler ce digDay ?"
      : decision === "notification"
      ? "envoyer un message de relance au collaborateur ?"
      : "Souhaitez-vous rejeter ce digDay ?";

  const handleSubmit = async (event) => {
    event.preventDefault();
    handleDigDayDecision(decision, formValue);
    modalVisibility(false);
  };

  const handleReset = () => {
    modalVisibility(false);
  };

  const handleChange = (event) => {
    setformValue({
      ...formValue,
      [event.target.name]: event.target.value,
    });
  };
  return (
    <div>
      <div className="quest-validation-form-header">
        <div>
          <i className="bx bx-error-circle bx-tada quest-validation-form-icon"></i>
        </div>
        <div className="quest-validation-form-title">{formTitle}</div>
      </div>
      <Form onSubmit={handleSubmit} onReset={handleReset}>
        <FormGroup>
          <Label for="message">Message</Label>
          <Input type="textarea" name="message" id="message" autoComplete="off" onChange={handleChange} required={decision === "notification"} />
        </FormGroup>
        <Row>
          <Col md={6}>
            <Button color="danger" type="reset" block>
              Annuler
            </Button>
          </Col>
          <Col md={6}>
            <Button color={submitButtonColor} type="submit" block>
              {submitButtonText}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default DigDaysDecisionForm;
